import gql from 'graphql-tag';
import UserAllDataFragment from './UserAllDataFragment';

export default gql`
fragment AuthenticationResultFragment on AuthenticationResult {
    token
    user {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AuthenticationResultFragment.ts